import React from 'react';
import { motion } from 'framer-motion';
import { PiggyBankIcon, TrendingUpIcon, ShieldIcon } from 'lucide-react';
export function OfferSection() {
  const pillars = [{
    title: 'EL HACK DEL AHORRO',
    icon: <PiggyBankIcon size={40} data-id="element-141" />,
    desc: 'Cómo usar la regla 50/30/20 para comprar lo que quieres sin sentirte culpable.'
  }, {
    title: 'LA MÁQUINA DE INVERSIÓN',
    icon: <TrendingUpIcon size={40} data-id="element-142" />,
    desc: 'Cómo abrir tu primera cuenta y poner tus primeros $5 a trabajar en el S&P 500 (100% legal para menores).'
  }, {
    title: 'BLINDAJE ANTI-ESTAFAS',
    icon: <ShieldIcon size={40} data-id="element-143" />,
    desc: 'Aprende a detectar "negocios milagrosos" de TikTok que solo quieren robarte tu dinero.'
  }];
  return <section className="py-24 px-4 bg-black/50 relative border-y border-white/5" data-id="element-144">
      <div className="max-w-6xl mx-auto text-center" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-146">
          <h2 className="text-3xl md:text-5xl font-black mb-4 font-orbitron" data-id="element-147">
            DINERO PRO: El Blueprint de Supervivencia Financiera
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-148">
            Este no es un curso de 10 horas. Es una guía de acción inmediata
            enfocada en 3 pilares:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-149">
          {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="glass-panel p-8 rounded-2xl text-left hover:neon-box-green transition-all duration-300 group" data-id="element-150">
              <div className="text-[#39FF14] mb-6 group-hover:scale-110 transition-transform duration-300 drop-shadow-[0_0_8px_rgba(57,255,20,0.5)]" data-id="element-151">
                {pillar.icon}
              </div>
              <h3 className="text-xl font-bold mb-4 font-orbitron tracking-wide" data-id="element-152">
                {pillar.title}
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-153">{pillar.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}